export default __webpack_public_path__ + "static/media/Permission.68380c45.svg";